export default __webpack_public_path__ + "static/media/history-mobile-2.d6003ef2.png";